import type { SYSAction } from "../../../../../../_ovlclient/src"
import { TableRefresh } from "../../../../../../_ovlclient/src/library/table/tableapi"

const HookScreenRefresh: SYSAction = async (_) => {
  await TableRefresh("SPCSymbolPC")
}

const HookScreenNavigateIn = async (_, { state, actions }) => {
  await TableRefresh("SPCSymbolPC")
}

let hooks = { HookScreenNavigateIn, HookScreenRefresh }
export let SPCSymbolPC = { hooks }
